var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4, _linearGradient5, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Coffee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "1zUM95tZK0w_~XGN4LzF8a",
    x1: 12.742,
    x2: 35.022,
    y1: 10.579,
    y2: 38.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fec52b"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#1zUM95tZK0w_~XGN4LzF8a)",
    d: "M10.5,11l2.83,30.187C13.426,42.214,14.289,43,15.321,43h17.357 c1.032,0,1.895-0.786,1.991-1.813L37.5,11H10.5z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "1zUM95tZK0w_~XGN4LzF8b",
    x1: 24,
    x2: 24,
    y1: 9.07,
    y2: 11.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a34f27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.587,
    stopColor: "#8b3817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#802d10"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#1zUM95tZK0w_~XGN4LzF8b)",
    d: "M38,9H10c-0.552,0-1,0.448-1,1v1h30v-1C39,9.448,38.552,9,38,9z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "1zUM95tZK0w_~XGN4LzF8c",
    x1: 24,
    x2: 24,
    y1: 4.992,
    y2: 9.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a34f27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#a04c25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#96421e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933,
    stopColor: "#853214"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#802d10"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#1zUM95tZK0w_~XGN4LzF8c)",
    d: "M35,5H13c-1.105,0-2,0.895-2,2v2h26V7C37,5.895,36.105,5,35,5z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "1zUM95tZK0w_~XGN4LzF8d",
    x1: 24,
    x2: 24,
    y1: -29.109,
    y2: 41.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fed100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e36001"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#1zUM95tZK0w_~XGN4LzF8d)",
    d: "M36.791,18H11.209c-0.294,0-0.525,0.253-0.498,0.546l1.581,17 C12.316,35.803,12.532,36,12.79,36h22.42c0.258,0,0.474-0.197,0.498-0.454l1.581-17C37.316,18.253,37.085,18,36.791,18z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "1zUM95tZK0w_~XGN4LzF8e",
    x1: 19.744,
    x2: 27.962,
    y1: 22.744,
    y2: 30.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fede00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd000"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 27,
    r: 6,
    fill: "url(#1zUM95tZK0w_~XGN4LzF8e)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Coffee);
export default __webpack_public_path__ + "static/media/icons8-coffee.37274cbad156e6d8003d8adeca8c45f0.svg";
export { ForwardRef as ReactComponent };